import React from 'react';
import CmsEmbed from '@reverbdotcom/commons/src/components/cms_embed';
import LoggedOutRecommendationsRow from '../../../recommended_listings/logged_out_recommendations_row';
import HomePageSellVisibilityV2 from '../homepage_sell_visibility_v2';
import HomepageTrendingSearches from '../homepage_trending_searches';
import HomepageCategoriesLegacy from '../../homepage_categories';
import HomepageCategoriesRedesign from '../homepage_categories';
import RecentArticles from '../recent_articles';
import HomepageNewsletter from '../homepage_newsletter';
import CmsListingsCollection from '@reverbdotcom/commons/src/cms/components/cms_listings_collection';
import HomepageDealsAndStealsListingsCollection from '../../../homepage_deals_and_steals_listings_collection';
import HomepageSell from '../homepage_sell';
import I18n from 'i18n-js';
import { useUser } from '@reverbdotcom/commons/src/user_hooks';
import { getItem } from '@reverbdotcom/commons/src/local_storage_utils';
import HomepageSearchRecommendationsContent from '../homepage_search_recommendations';
import { buildRecentSearches } from '../../site_search/reverb_site_search_suggestions';
import {
  HomepageDealsAndStealsPersonalizedListingsCollection,
} from '../../../../components/homepage_deals_and_steals_personalized_listings_collection';
import AppCallout from '../app_callout';
import BasedOnRecentlyViewed from '../based_on_recently_viewed';
import BestSellingBrands from '../best_selling_brands';
import ValueProps from '../value_props';
import { MostWatchedListings } from '../most_watched_listings';

export function RecommendationsRow() {
  return (
    <LoggedOutRecommendationsRow />
  );
}

export function AnyoneCanSellRow() {
  return (
    <HomePageSellVisibilityV2 />
  );
}

export function TrendingSearches() {
  return (
    <HomepageTrendingSearches />
  );
}

export function HomepageEmbed() {
  return (
    <CmsEmbed slug="homepage-embed" ssrMode="static-only" />
  );
}

export function Categories({ useRedesign = false }) {
  if (useRedesign) {
    return <HomepageCategoriesRedesign />;
  } else {
    return (
      <HomepageCategoriesLegacy
        title={I18n.t('discovery.homepage.loggedOutNew.shopByInstrument')}
      />
    );
  }
}

export function Articles() {
  return (
    <RecentArticles
      title={I18n.t('discovery.homepage.loggedOutNew.explore')}
    />
  );
}

export function NewsletterSignup() {
  return (
    <HomepageNewsletter signupReason="loggedouthomepage" />
  );
}

export function NewGearRow() {
  const user = useUser();
  return (
    <CmsListingsCollection
      ctaTargetHref="/marketplace?condition=used"
      conditionSlugs={['used']}
      userShippingRegion={user.shippingRegionCode}
      componentName="HomepageLatestListings"
      maxCount={12}
      largeTiles
      ssr={false}
      title={I18n.t('discovery.homepage.loggedOutNew.latestGear')}
    />
  );
}

export function DealsAndSteals() {
  return (
    <HomepageDealsAndStealsListingsCollection
      title={I18n.t('discovery.homepage.loggedOutNew.dealsAndSteals')}
    />
  );
}

export function DealsAndStealsForYou({ mpid }) {
  return <HomepageDealsAndStealsPersonalizedListingsCollection mpid={mpid} />;
}

export function SellYourGear() {
  return (
    <HomepageSell />
  );
}

export function HomepageSearchRecommendations() {
  const recentSearches = buildRecentSearches(getItem('RECENT_SEARCHES') || [])?.suggestions[0]?.results || [];
  return <HomepageSearchRecommendationsContent recentSearches={recentSearches} />;
}

export function MostWatchedRow({ mpid }) {
  return <MostWatchedListings mpid={mpid} />;
}

export function ReverbAppCallout() {
  return <AppCallout />;
}

export function BasedOnYourRecentlyViewed() {
  return <BasedOnRecentlyViewed />;
}

export function Brands() {
  return <BestSellingBrands />;
}

export function LoggedOutValueProps() {
  return <ValueProps />;
}
